<ngx-spinner 
bdColor = "rgba(0, 0, 0, 0.8)" 
size = "medium" color = "#ee0909" 
type = "ball-atom" 
[fullScreen] = "true">
<p style="color: white" > cargando .... </p>
</ngx-spinner>

<div class="container">
    <div class="row">
        <div class="border">
</div>

<app-sectores-estandares [title]="estandarNB" (sectorEsById)="onSectorEsById($event)" *ngIf="subSectEs && !esmarca" (estandarBackTo)="estandarOnBack($event)" (estandar)="setEstandar($event)"></app-sectores-estandares>
<app-sectores-estandares [estandarDes]="estandarDes" [idSector]="idSect" [padre] ="idSect" (sectorEsById)="onEstandarBySector($event)" [title]="estandarNB" [tablaEstandar]="tablaEstandar" *ngIf="estandar" (estandarBackTo)="estandarOnBack($event)"></app-sectores-estandares>
<app-transversales  *ngIf="trasnversal"></app-transversales>
<app-estandares-marca [title]="estandarNB" (sectorEsById)="onTablaEstandaresMarca($event)" *ngIf="subSectEs"  ></app-estandares-marca>
<app-estandares-marca [title]="estandarNB" (sectorEsById)="onDeesEstandarMarcaBySector($event)"  *ngIf="esmarca" [marca]="marca" (backTo)="estandarMarcaOnBack($event)"  ></app-estandares-marca>
<estandares [estandarDes]="estandarDes" [title]="estandarNB" [idSector]="idSect" [padre] ="padre"  (sectorEsById)="onDeesEstandarBySector($event)" *ngIf="listEstandar" (backTo)="onBackSubsec($event)"></estandares>
<desEstandares [title]="estandarNB" [idSector]="idSect" [padre] ="padre" [codigoEC]="codigoEC"  *ngIf="desEstandar" (backTo)="onBackEstandare($event)"></desEstandares>
<desEstandares [title]="estandarNB"  [codigoEC]="codigoEC"  *ngIf="desEstandarMarca"  (backTo)="estandarMarcaOnBack($event)"></desEstandares>
</div>
</div>